<template>
  <div class="userManage">
    <div class="userManageBox">
      <el-row>
        <el-col :span="20">数据筛选</el-col>
        <el-col :span="4">
          <el-button type="success" round icon="el-icon-check" size="small" @click="searchData">确 认</el-button>
          <el-button type="info" round icon="el-icon-refresh-left" size="small" @click="clearFilter()">重 置</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="10" class="filter">
        <el-col :span="6">
          <span class="label">用户</span>
          <el-input
            v-model="filterData.searchTerm"
            placeholder="用户ID或名称"
            style="width: auto"
          ></el-input>
        </el-col>
        <el-col :span="6">
          <span class="label">区域</span>
          <el-select
            class="area"
            v-model="filterData.region"
            placeholder="请选择"
            multiple
            @change=changeFilter
          >
            <el-option
              v-for="item in areaList"
              :key="item.no"
              :label="item.name"
              :value="item.no">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <span class="label">客户</span>
          <el-select
            class="area"
            v-model="filterData.reseller"
            placeholder="请选择"
            multiple
            @change=changeFilter
          >
            <el-option
              v-for="item in customerList"
              :key="item.no"
              :label="item.name"
              :value="item.no">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <span class="label">角色</span>
          <el-select
            class="area"
            v-model="filterData.role"
            placeholder="请选择"
            multiple
            @change=changeFilter
          >
            <el-option
              v-for="item in roleList"
              :key="item.no"
              :label="item.name"
              :value="item.no">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
<!--      <el-row :gutter="10" class="filter">-->
<!--        <el-col :span="6">-->
<!--          <span class="label">二级客户</span>-->
<!--          <el-select-->
<!--            class="area"-->
<!--            v-model="filterData.secondResellers"-->
<!--            placeholder="请选择"-->
<!--            multiple-->
<!--            @change=changeFilter-->
<!--          >-->
<!--            <el-option-->
<!--              v-for="item in secondResellerList"-->
<!--              :key="item"-->
<!--              :label="item"-->
<!--              :value="item">-->
<!--            </el-option>-->
<!--          </el-select>-->
<!--        </el-col>-->
<!--      </el-row>-->
      <el-divider></el-divider>

      <el-row>
        <el-col :span="20">数据列表</el-col>
        <!--<el-col :span="2">
          <el-button
            plain
            round
            icon="el-icon-plus"
            size="small"
            style="color: #67C23A"
            @click="openCreate()"
          >
            新 建
          </el-button>
        </el-col>-->
        <el-col :span="4">
          <el-button style="color: #67C23A; margin-right: 20px" type="text" @click="downloadTemplate"><i
            class="el-icon-info"></i>模板下载</el-button>
          <input type="file" ref="importFile" @change="importExcel" />
          <el-button
            plain
            round
            icon="el-icon-upload2"
            size="small"
            style="color: #67C23A"
            @click="$refs.importFile.click()">
            导 入
          </el-button>
        </el-col>
      </el-row>

      <el-table
        style="width: 100%; margin-top: 20px"
        fit
        stripe
        :data="tableData"
        v-loading="tableLoading"
        border
      >
        <el-table-column
          sortable
          prop="name"
          label="用户名称"
          width="230"
        ></el-table-column>
        <el-table-column
          sortable
          prop="cellphone"
          label="手机号"
          width="230"
        ></el-table-column>
        <el-table-column
          prop="regionName"
          label="区域"
          width="230"
        >
        </el-table-column>
        <el-table-column
          prop="resellerName"
          label="客户"
        >
        </el-table-column>
        <el-table-column
          prop="secondReseller"
          label="二级客户"
        >
        </el-table-column>
        <el-table-column
          prop="roleName"
          label="角色"
          width=""
        >
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="text" style="color: #606266" icon="el-icon-edit" size="mini" @click="openEdit(scope.row.id)"
            >编辑</el-button>
            <el-button type="text" style="color: #606266" icon="el-icon-delete" size="mini" @click="onDelete(scope.row.id)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <footer>
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="currentChange"
          :current-page="tableConfig.current"
          :total="total"
        ></el-pagination>
      </footer>
    </div>
  </div>
</template>
<script>
import md5 from "md5";
import _ from "lodash";

export default {
  name: "UserManage",
  data() {
    return {
      filterData: {},
      initialFilterData: {
        region: [], //区域
        reseller: [], //客户
        secondResellers: [], //二级客户
        role: [], // 角色
        searchTerm: "" //搜索项
      },
      areaList: [],
      customerList: [],
      roleList: [],
      secondResellerList: [],
      tableData: [], // 列表
      total: 10, // 总数量
      tableConfig: {
        size: 10, // 每页数量
        current: 1, // 当前页码
      },
      tableLoading: false
    }
  },
  mounted() {
    this.getData();
    this.clearFilter();
    this.getOptions();
  },
  methods: {
    async getOptions() {
      let res = await axios.post(vmsReqUrl+"account/queryConditions", _.omit(this.filterData, ['searchTerm']));
      if (res.data.code === 200) {
        const dataList = res.data.data;
        this.areaList = dataList.region;
        this.customerList = dataList.reseller;
        this.roleList = dataList.role;
        this.secondResellerList = dataList.secondReseller
      }
    },
    clearFilter() {
      this.filterData = _.cloneDeep(this.initialFilterData);
      this.getOptions();
    },
    changeFilter() {
      this.getOptions();
    },
    searchData () {
      this.tableConfig.current = 1;
      this.getData();
    },
    async getData() {
      // 获取列表
      this.tableLoading = true;
      const params = _.assign({}, this.tableConfig, this.filterData);
      let res = await axios.post(vmsReqUrl+"account/list", params);
      res = res.data
      if (res.code === 200) {
        this.tableData = res.data.records || [];
        this.total = res.data.total;
      }
      this.tableLoading = false;
    },
    currentChange(index) {
      // 分页
      this.tableConfig.current = index;
      this.getData();
    },
    openEdit(id) {
      console.log('id', id);
      this.$router.push({ path: '/vms/userEdit', query: { id } });
    },
/*    openCreate() {
      this.$router.push({ path: '/pages/userEdit' });
    },*/
    async importExcel({ target }) {
      let formData = new FormData();
      formData.append("file", target.files[0]);
      let res = await axios.post(vmsReqUrl+"account/batchImportAccount", formData);
      if(res.data.code === 200) this.$message.success("导入成功！");
      else this.$message.error("导入失败！");
    },
    async onDelete(id) {
      this.$confirm("确认删除吗？", "提示",{
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async() => {
          let res = await axios.delete(vmsReqUrl+"account/" + id);
          res = res.data
          if (res.code === 200) {
            await this.getData()
            this.$message.success(res.message)
          }else {
            // this.$message.warning(res.message)
          }
        })
        .catch(_ => {})
    },
    async downloadTemplate() {
      let response = await axios({
        method: "post",
        responseType: "blob",
        url: vmsReqUrl+"/account/importTemplate",
      });

      let fileName = decodeURI(
        response.headers["content-disposition"].split("''")[1]
      );
      let res = response.data;
      const blob = new Blob([res], { type: "application/vnd.ms-excel" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = fileName;
      a.click();
      URL.revokeObjectURL(a.href);
      a.remove();
    },
  }
};
</script>
<style lang="sass" scoped>
.userManage
  min-width: 1050px
  input[type=file]
    display: none
  .userManageBox
    padding: 20px
    .title
      color: #6F6F6F
      font-size: 26px
      font-weight: 600
      letter-spacing: 2px
      text-align: center
      margin-bottom: 30px
    .filter
      margin-top: 30px
    .label
      font-size: 14px
      color: #606266
    .table-container
      margin-top: 20px
    footer
      padding-top: 20px
      text-align: right
</style>



// WEBPACK FOOTER //
// src/vms/pages/views/userManage.vue